import React from 'react'
import DashboardIcon from '../elements/icons/DashboardIcon'
// import TicketsIcon from '../elements/icons/TicketsIcon'
import { NavLink, useLocation } from 'react-router-dom'
// import ScaleIcon from '../elements/icons/ScaleIcon'
// import DocSearchIcon from '../elements/icons/DocSearchIcon'
import UsersIcon from '../elements/icons/UsersIcon'
// import MicrophoneIcon from '../elements/icons/MicrophoneIcon'
// import MoneyIcon from '../elements/icons/MoneyIcon'
// import ClipboardIcon from '../elements/icons/ClipboardIcon'
// import CalendarIcon from '../elements/icons/CalendarIcon'
import AcademicCapIcon from '../elements/icons/AcademicCapIcon'
// import WalletIcon from '../elements/icons/WalletIcon'
// import FolderArrowDownIcon from '../elements/icons/FolderArrowDownIcon'
// import ClipboardDocumentCheckIcon from '../elements/icons/ClipboardDocumentCheckIcon'
import BookIcon from '../elements/icons/BookIcon'
import BriefcaseIcon from '../elements/icons/BriefcaseIcon'
import BuildingOfficeIcon from '../elements/icons/BuildingOfficeIcon'
// import CogIcon from '../elements/icons/CogIcon'
import BoxIcon from '../elements/icons/BoxIcon'
import UserGroupIcon from '../elements/icons/UserGroupIcon'
import CogIcon from '../elements/icons/CogIcon'
// import VcmLogo from '../../assets/images/vcm-logo-placeholder.svg'
// test deploy dev
const Sidebar = () => {
    const location = useLocation();
    const currentRoute = location.pathname;
    return (
        <div className="w-full min-h-screen bg-gray-50 px-4 pt-12 relative">
            {/* <div className="pt-3 w-full flex items-center gap-x-2 mb-12">
                <img src={VcmLogo} alt="" className="w-[30px]" />
                <h1 className="text-lg text-gray-600 tracking-[0.1em] font-thin uppercase">Vaatia College</h1>
            </div> */}
            <NavLink to="/admin/dashboard" className={`${currentRoute.includes('admin/dashboard') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <DashboardIcon className={`h6 w-6`} />
                </div>
                Dashboard
            </NavLink>

            <NavLink to="/admin/administration" className={`${currentRoute.includes('admin/administration') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <BuildingOfficeIcon className={`h6 w-6`} />
                </div>
                Administration
            </NavLink>

            <NavLink to="/admin/accounting" className={`${currentRoute.includes('admin/accounting') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <BriefcaseIcon className={`h6 w-6`} />
                </div>
                Finance & Accounting
            </NavLink>

            <NavLink to="/admin/academics" className={`${currentRoute.includes('admin/academics') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <BookIcon className={`h6 w-6`} />
                </div>
                Academics
            </NavLink>

            <NavLink to="/admin/parents"  className={`${currentRoute.includes('admin/parents') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <UsersIcon className={`w-6 h-6`} />
                </div>
                Parents
            </NavLink>

            <NavLink to="/admin/students" className={`${currentRoute.includes('admin/students') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <AcademicCapIcon className={`w-6 h-6`} />
                </div>
                Students
            </NavLink>

            <NavLink to="/admin/college-staff" className={`${currentRoute.includes('admin/college-staff') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <UserGroupIcon className={`w-6 h-6`} />
                </div>
                College Staff
            </NavLink>

            <NavLink to="/admin/inventory"  className={`${currentRoute.includes('admin/inventory') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <BoxIcon className={`w-6 h-6`} />
                </div>
                Inventory
            </NavLink>

            {/* <div className='absolute bottom-[20px]'> */}
            <NavLink to="/admin/settings" className={`${currentRoute.includes('admin/settings') ? 'text-purple-700' : 'text-black'} text-sm flex p-2 rounded-md w-full flex-row gap-x-4 items-center mb-2`}>
                <div className="p-1">
                    <CogIcon className={`w-6 h-6`} />
                </div>
                Settings
            </NavLink>
            {/* </div> */}

        </div>
        
    )
}

export default Sidebar
